export const defaultTaxPayerInfoState = {
	taxPayerInfo: null,
	IsViewGuideUser: false,
	cqtPopupDismissed: false,
	amisConvertFailNotiShown: false
};

export default {
	...defaultTaxPayerInfoState
};
